import _ from "lodash";

import { UnknownAction } from "@reduxjs/toolkit";
import { PaginatedRecords } from "src/types/common";
import { Opportunity } from "src/types/conversations";
import { FETCH_INTEGRATION_OPPORTUNITIES_REQUEST, FETCHING_INTEGRATION_OPPORTUNITIES_FAILED, FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED, INVALIDATE_INTEGRATION_OPPORTUNITIES } from "../actions/actionTypes";
import { FetchIntegrationOpportunitiesFailed } from "src/types/opportunities";

export interface OpportunityState {
  items: Opportunity[];
  pagination: {
    currentPage: number;
    totalPages: number;
    recordsPerPage: number;
  };
  loading: boolean;
  error: any;
}

const initialState = {
  items: [],
  loading: false,
  pagination : {
    currentPage: 0,
    totalPages: 0,
    recordsPerPage: 0,
  },
  error: null
}

export function OpportunityReducer(
  state: OpportunityState = initialState,
  action: UnknownAction,
){
  switch(action.type){
    case FETCH_INTEGRATION_OPPORTUNITIES_REQUEST:{
      return {
        ...state,
        loading: true,
      };
    }

    case FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED:{
      const { currentPage, records, totalPages, nextPage } = action.payload as PaginatedRecords<Opportunity>;
      let updatedRecords = currentPage != 0 ? [...state.items, ...records] : records || [];

      updatedRecords =_.uniqBy(updatedRecords, 'id');
      return {
        ...state,
        loading: false,
        pagination: {
          ...state.pagination,
          currentPage,
          totalPages,
          nextPage: nextPage ?? 0
        },
        items: updatedRecords,
      };
    }
    case FETCHING_INTEGRATION_OPPORTUNITIES_FAILED:{
      const { error } = action.payload as FetchIntegrationOpportunitiesFailed;
      return {
        ...state,
        loading: false,
        error,
      };
    }

    case INVALIDATE_INTEGRATION_OPPORTUNITIES:{
      return {
        ...state,
        items: []
      };
    }

    default:
      return state;
  }
}